import { createLocale } from "@/core/utils/get-supported-locale"
import { LocaleType } from "@/core/utils/get-supported-locale/types"

export const defaultLocale = createLocale("en", "GB")

export const knownLocales: LocaleType[] = [
  createLocale("en", "GB"),
  createLocale("sv", "SE"),
  createLocale("da", "DK"),
  createLocale("de", "DE"),
  createLocale("es", "ES"),
  createLocale("fi", "FI"),
  createLocale("fr", "FR"),
  createLocale("it", "IT"),
  createLocale("nb", "NO"),
  createLocale("nl", "NL"),
  createLocale("pt", "BR"),
  createLocale("es", "MX"),
]

export const availableTranslations: LocaleType[] = [
  createLocale("en", "GB"),
  createLocale("sv", "SE"),
]

export const availableLinkLocales: LocaleType[] = [
  createLocale("en", "GB"),
  createLocale("sv", "SE"),
  createLocale("da", "DK"),
  createLocale("de", "DE"),
  createLocale("es", "ES"),
  createLocale("fi", "FI"),
  createLocale("fr", "FR"),
  createLocale("it", "IT"),
  createLocale("nb", "NO"),
  createLocale("nl", "NL"),
  createLocale("pt", "BR"),
  createLocale("es", "MX"),
]

export const OPT_OUT_SUCCESS_STATUS = "success"
export const OPT_OUT_FAILURE_STATUS = "failure"

export const CustomerEmailRegex = /^[^@^\s]+@[a-zA-Z0-9._-]+\.[a-zA-Z]+$/
export const NameRegex = /^(?!.*[\t\n])([\p{L}\p{M}]+['.-]?\s*)+$/u
export const FirstNameMaxLength = 100
export const LastNameMaxLength = 100
export const companyNameMaxLength = 300
export const CustomerSignupNoteMaxLength = 1000

export const PaypalPrivacyPortalLink = "https://www.paypal.com/myaccount/privacy/zettle/"

export const PaypalPrivacyStatementLink =
  "https://www.paypal.com/us/webapps/mpp/ua/privacy-full"
